import { captureException } from '@sentry/browser';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

import { CustomLoader } from '@/components/elements/loader';
import { getScheduleColor } from '@/components/modules/orders-page/utils/get-schedule-color';
import { getScheduleName } from '@/components/modules/orders-page/utils/get-schedule-name';

import { TErrorData, TPaymentSchedule, getQuestionnairePaymentSchedule } from '@/shared/api';
import { useShowTechnicalError } from '@/shared/hooks/use-show-technical-error';

import * as Styled from './styled';

type TRentCalendarProps = {
    number: string;
};

export const RentCalendar: React.FC<TRentCalendarProps> = ({ number }) => {
    const [paymentScheduleList, setPaymentScheduleList] = useState<TPaymentSchedule[]>([]);

    const [isLoading, setIsLoading] = useState(false);

    const { showError } = useShowTechnicalError();

    useEffect(() => {
        setIsLoading(true);

        (async () => {
            try {
                const responsePaymentSchedule = await getQuestionnairePaymentSchedule(number);

                setPaymentScheduleList(responsePaymentSchedule);

                setIsLoading(false);
            } catch (err) {
                const error = err as AxiosError;

                const response = error.response?.data as TErrorData;

                captureException(error);

                showError(response?.message);

                setIsLoading(false);
            }
        })();
    }, []);

    if (isLoading) {
        return (
            <Styled.LoaderWrapper>
                <CustomLoader />
            </Styled.LoaderWrapper>
        );
    }

    return (
        <Styled.Wrapper>
            {paymentScheduleList.map((schedule) => {
                const date = dayjs(schedule.payDate, 'YYYY-MM-DD').locale('ru').format('D MMMM');

                return (
                    <Styled.Line color={getScheduleColor(schedule.status)} key={schedule.index}>
                        <span>{date}</span>
                        <span>
                            {getScheduleName(schedule.status)} {schedule.totalDebtAccrued} ₸
                        </span>
                    </Styled.Line>
                );
            })}
        </Styled.Wrapper>
    );
};
